const getters = {
  // 定义showTabBar方法，传入state，返回state.common.showTabBar
  showTabBar: state => state.common.showTabBar
}
export default getters
